export class BenefitAmount{
    withCurrentMembership: number;
    withUpgradedMembership: number;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/ocean-upgrade/benefit-amount.model.ts